import script from "./indexpersonal.vue?vue&type=script&setup=true&lang=js"
export * from "./indexpersonal.vue?vue&type=script&setup=true&lang=js"

import "./indexpersonal.vue?vue&type=style&index=0&id=41ce62ca&lang=css"

const __exports__ = script;

export default __exports__